import React, { useEffect } from "react";
import { FaGithub, FaTwitter } from "react-icons/fa";
import { IoLogoLinkedin, IoLogoWhatsapp } from "react-icons/io";
import { SiHashnode } from "react-icons/si";
import Aos from "aos";

const Footer = () => {
  useEffect(() => {
    Aos.init();
  });
  const today = new Date();
  return (
    <React.Fragment>
      <div className="bg-[#1F1F38] p-8 text-[#FFFFFF] font-bold ">
        <div className="lg:flex justify-evenly items-center">
          <div className="flex flex-col justify-center items-center gap-4 p-4 mb-5">
            <h1>Let's connect on :</h1>
            <ul data-aos="zoom-in-up" className="flex gap-14">
              <a
                className="hover:text-[#E84949] hover:scale-150 duration-500"
                href="https://www.linkedin.com/in/haruna-idris-68aa3223a/"
              >
                <IoLogoLinkedin size={30} />
              </a>
              <a
                className="hover:text-[#E84949] hover:scale-150 duration-500"
                href="https://wa.link/aur5ve"
              >
                <IoLogoWhatsapp size={30} />
              </a>
              <a
                className="hover:text-[#E84949] hover:scale-150 duration-500"
                href="https://twitter.com/I_am_eedris"
              >
                <FaTwitter size={30} />
              </a>
              <a
                className="hover:text-[#E84949] hover:scale-150 duration-500"
                href="https://hashnode.com/@IdrisHaruna"
              >
                <SiHashnode size={30} />
              </a>
            </ul>
          </div>
          <div
            data-aos="zoom-in-up"
            className="flex flex-col justify-center items-center gap-2"
          >
            <h1>Check more projects on </h1>
            <p className="flex justify-center items-center ">
              <a
                className="hover:text-[#E84949] hover:scale-150 duration-500"
                href="https://github.com/eedrisofficial"
              >
                <FaGithub />
              </a>
            </p>
            <p>
              <a
                href="https://github.com/eedrisofficial"
                className="text-[#E84949] hover:underline p-1"
              >
                @eedrisofficial
              </a>
              on github
            </p>
          </div>
        </div>
        <p className=" text-center">
          &copy; {today.getFullYear()} || All Rights Reserved
        </p>
      </div>
    </React.Fragment>
  );
};

export default Footer;
